import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=e8a22cb6&scoped=true&"
import script from "./txt.vue?vue&type=script&lang=js&"
export * from "./txt.vue?vue&type=script&lang=js&"
import style0 from "./txt.vue?vue&type=style&index=0&id=e8a22cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a22cb6",
  null
  
)

export default component.exports